// TODO: implementation
export const isLoggedIn = false

export const login = async () => {
  return false
}

export const getToken = () => {
  return {
    access_token: "",
    last_login: "",
    refresh_token: ""
  }
}